import { render, staticRenderFns } from "./ClassroomDetail.vue?vue&type=template&id=053ed106&scoped=true"
import script from "./ClassroomDetail.vue?vue&type=script&lang=ts"
export * from "./ClassroomDetail.vue?vue&type=script&lang=ts"
import style0 from "./ClassroomDetail.vue?vue&type=style&index=0&id=053ed106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ed106",
  null
  
)

export default component.exports